import { Component } from '@angular/core';
import { RoomSelectionService } from './room-selection.service';
import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { ErrorListComponent } from '../../../reusable-components/error-list/error-list.component';
import { ErrorListService } from '../../../reusable-components/error-list/error-list.service';

@Component({
  selector: 'app-room-selection',
  imports: [NgComponentOutlet, ErrorListComponent, AsyncPipe],
  templateUrl: './room-selection.component.html',
  styleUrl: './room-selection.component.scss',
  providers: [
    RoomSelectionService,
    {
      provide: ErrorListService,
      useFactory: (roomSelectionService: RoomSelectionService) =>
        roomSelectionService.getErrorListService(),
      deps: [RoomSelectionService],
    },
  ],
})
export class RoomSelectionComponent {
  constructor(protected roomSelectionService: RoomSelectionService) {}
}
